module.exports = __webpack_public_path__ + "static/img/bg_rank.74254e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_rank.png
// module id = f2Mm
// module chunks = 1